// See services/sosInventoryService/README.md for information about the structure
// of schema.js files.
export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: [],
  MONEY_FIELDS: [],
  DATE_FIELDS: [],
  DATETIME_FIELDS: ["txnDate"],
  NON_UTC_DATETIME_FIELDS: [],
};
